<div
  class="whitespace-nowrap d-flex flex-nowrap gap-2"
  [ngClass]="[
    !column().withoutSort ? 'cursor-pointer' : 'pointer-events-none',
    column().class || '',
    last() ? ' justify-content-end ' : '',
  ]"
  [ngStyle]="{ 'min-width': column().minWidth, width: column().width }"
  (click)="onSortChanged()"
  (keyup.enter)="onSortChanged()"
  tabindex="0"
  role="button"
>
  <span class="resize-td">{{ t()(column().translationKey) }}</span>
  @if (!column().withoutSort && sortField() === column().field) {
    <span
      class="d-inline-block sort-icon"
      [class.rotate-180]="sortOrder() === 'DESC'"
    >
      <ui-keenicon name="arrow-down"></ui-keenicon>
    </span>
  }
</div>
